import { createAction } from '@reduxjs/toolkit';
import { trackError } from 'utils/helpers';
import EcomEngineAPI from 'api/ecom_engine_api';

const fetchFerryServicesStarted = createAction(
  'reservation/fetchFerryServicesStarted'
);
const fetchFerryServicesSucceeded = createAction(
  'reservation/fetchFerryServicesSucceeded'
);
const fetchFerryServicesFailure = createAction(
  'reservation/fetchFerryServicesFailure'
);
const setFerryServices = createAction('reservation/setFerryServices');

const fetchFerryServices = (segmentId) => (dispatch, getState) => {
  dispatch(fetchFerryServicesStarted({ segmentId }));
  dispatch(setFerryServices({ segmentId, services: [] }));
  const state = getState();
  const groupingValues = state.ui.sealink.ferryGrouping[0].values;
  const passenger_types = groupingValues.passengerForm.passengers;
  const { journeys, journeyType, journeyDates } = groupingValues.journeyForm;
  const { vehicles } = groupingValues.vehicleForm;
  const add_return = journeyType === 'return';

  const allRoutes = state.routes;

  const segment = state.sealink.segments[segmentId.toString()];
  const route_id = segment.qt_route_id;
  const { is_primary_segment } = segment;

  const journeyIndex = journeys[0].segments.includes(segmentId) ? 0 : 1;
  const [first_travel_date] = journeyDates[journeyIndex].split('T');

  const from_route_stop_id =
    journeys[journeyIndex].segmentStops[segmentId].departureRouteStop.id;
  const to_route_stop_id =
    journeys[journeyIndex].segmentStops[segmentId].arrivalRouteStop.id;

  // vehicle.id only available when editing a booking
  const vehicleTypes = [];
  vehicles.forEach((vehicle) => {
    vehicleTypes.push(
      vehicle.id
        ? vehicle
        : {
            ...vehicle.finalDimensions,
            vehicle_type_id: vehicle.vehicleTypeId,
            attachment_ids: vehicle.attachmentIds || [],
          }
    );

    // If vehicle with trailer
    if (vehicle.trailerRadio) {
      vehicleTypes.push({
        height: vehicle.trailerHeight,
        length: vehicle.trailerLength,
        details: vehicle.trailerDescription,
        vehicle_type_id: state.sealink.vehicle_types.find(
          (vehicleType) => vehicleType.id === Number(vehicle.trailerRadio)
        ).qt_vehicle_type_id,
      });
    }
  });

  const params = {
    product_type_id: allRoutes[route_id].product_type_id, // Hard Coded
    route_id,
    from_route_stop_id,
    to_route_stop_id,
    show: 'inventory_exists', // Hard Coded
    forward: {
      first_travel_date,
      vehicle_types: vehicleTypes,
      passenger_types,
      from_route_stop_id,
      to_route_stop_id,
    },
    add_return,
  };

  if (!is_primary_segment) {
    params.forward.vehicle_types = [];
  }

  return EcomEngineAPI.reservation
    .findServices(params)
    .then((json) => {
      dispatch(fetchFerryServicesSucceeded({ segmentId, json }));
      dispatch(setFerryServices({ segmentId, services: json }));
    })
    .catch((error) => {
      trackError(error);
      dispatch(
        fetchFerryServicesFailure({ segmentId, message: error.message })
      );
    });
};

export {
  fetchFerryServicesStarted,
  fetchFerryServicesSucceeded,
  fetchFerryServicesFailure,
  fetchFerryServices,
  setFerryServices,
};
